import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'
import { useUserStore } from '@/gp/UserStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLink',
  props: {
  userId: String,
  dimmed: Boolean,
  static: Boolean,
},
  setup(__props) {

const props = __props;



const userStore = useUserStore()

const userRef = computed(() => userStore.getAsyncUser(props.userId)?.data) // should be loaded by parent component
const displayNameRef = computed(() => userRef.value?.isSystemUser ? "System" : userRef.value?.displayName)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["user-link", { 'dimmed': __props.dimmed, 'static': __props.static }])
  }, [
    (__props.static)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(displayNameRef.value), 1)
        ], 64))
      : (userRef.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: userRef.value.pageUrl
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(displayNameRef.value), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
  ], 2))
}
}

})